module.exports = __webpack_public_path__ + "img/apartment-gray.06fde7f1.png";